import React from "react";
import UserManagementDateTime from "./UserManagementDateTime";

const localizedReason = (group, language) =>
  group.reasonTranslations?.[language] ||
  group.reasonTranslations?.[language === "ar" ? "en" : "ar"] ||
  group.reason ||
  "—";

const reviewerName = (group, text) => {
  const reviewer = group.reviewedBy;
  const name = reviewer?.fullName ||
    [reviewer?.firstName, reviewer?.lastName].filter(Boolean).join(" ") ||
    reviewer?.email;
  if (name) return name;
  if (group.reviewedAt || (
    group.reviewStatus && group.reviewStatus !== "PENDING_REVIEW"
  )) {
    return text.reviewerUnavailable;
  }
  return text.notReviewedYet;
};

const groupGalleryItems = (submission, group, text) =>
  (group.files || []).map((file, index) => ({
    key: `${submission.id}:${group.group}:${file.id}`,
    kind: "submission",
    submissionId: submission.id,
    group: group.group,
    fileId: file.id,
    title:
      file.originalFileName ||
      `${text.reviewGroups[group.group] || group.group} ${index + 1}`
  }));

const RegistrationSubmissionHistory = ({
  submissions = [],
  language,
  text,
  loading = "",
  onViewGallery,
  currentSubmissionId
}) => (
  <div className="registration-history-table-wrap">
    <table className="registration-history-table">
      <thead>
        <tr>
          <th>{text.attempt}</th>
          <th>{text.uploadedAt}</th>
          <th>{text.documentGroup}</th>
          <th>{text.reviewStatus}</th>
          <th>{text.reason}</th>
          <th>{text.reviewer}</th>
          <th>{text.reviewedAt}</th>
          <th>{text.images}</th>
        </tr>
      </thead>
      <tbody>
        {submissions.flatMap((submission) =>
          (submission.groups || []).map((group) => {
            const galleryItems = groupGalleryItems(submission, group, text);
            const galleryLoading = galleryItems.some((item) => item.key === loading);
            return (
              <tr key={`${submission.id}-${group.id || group.group}`}>
                <td>
                  <span className="registration-history-attempt">
                    <strong>#{submission.submissionNumber}</strong>
                    {String(submission.id) === String(currentSubmissionId) && (
                      <small>{text.currentUpload}</small>
                    )}
                  </span>
                </td>
                <td><UserManagementDateTime value={submission.createdAt} language={language} /></td>
                <td>{text.reviewGroups[group.group] || group.group}</td>
                <td>{text.statusLabels[group.reviewStatus] || group.reviewStatus || "—"}</td>
                <td>{localizedReason(group, language)}</td>
                <td>{reviewerName(group, text)}</td>
                <td><UserManagementDateTime value={group.reviewedAt} language={language} /></td>
                <td>
                  <button
                    type="button"
                    className="registration-history-view"
                    disabled={!galleryItems.length || galleryLoading}
                    onClick={() => onViewGallery?.(galleryItems, 0)}
                  >
                    <i className="fa-regular fa-images" aria-hidden="true" />
                    <span>
                      {galleryLoading ? text.openingDocument : text.viewImages}
                      {galleryItems.length > 0 ? ` (${galleryItems.length})` : ""}
                    </span>
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
    {submissions.length === 0 && (
      <div className="registration-history-empty">{text.noUploadAttempts}</div>
    )}
  </div>
);

export default RegistrationSubmissionHistory;
